import React from "react";
import "../assets/css/loader.css";
function Loader(props) {
  return (
    <div>
      <div id="loop" className="center"></div>
      {/* <div id="bike-wrapper" className="center">
          <div id="bike" className="centerBike"></div>
        </div> */}
      <div id="preloader" className="center">
        <div id="loader"></div>
      </div>
    </div>
  );
}

export default Loader;
